import { Injectable } from '@angular/core';
import { CloudFunctionsApiService } from './cloud-functions-api.service';

@Injectable({
  providedIn: 'root',
})
export class LicenciaService {
  constructor(private api: CloudFunctionsApiService) {}

  getLicencia() {
    return this.api.snapshotList('/licenses');
  }

  getLicenciaById(uid) {
    return this.api.getDocument(`/licenses/${uid}`);
  }

  createdLicencia(licencia) {
    return this.api.post('/licenses', licencia).toPromise();
  }

  updateLicencia(uid, licencia) {
    return this.api.patch(`/licenses/${uid}`, licencia).toPromise();
  }

  searchLicencia(licencia) {
    return this.api.snapshotList(`/licenses/code/${encodeURIComponent(licencia)}`);
  }

  searchLicenciaNow(licencia) {
    return this.api.getCollection(`/licenses/code/${encodeURIComponent(licencia)}`);
  }
}
